/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:33:22
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-11 15:23:05
 */

export default {
  path: 'trade_tax',
  component: () => import(/* webpackChunkName: "tax-list" */ '@/pages/trade/TaxList'),
  meta: {title:'交易流水'}
}
